import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import QuestionTypeSelect from "../QuestionTypeSelect";
import FormAddQuestionFooter from "./FormAddQuestionFooter";
import QuestionDescription from "../QuestionDescription";
import { IQuestionForm } from "../../../types";
import AnswerField from "../AnswerField";
import AddAnswerButton from "../AddAnswerButton";
import { FC, useContext, useEffect } from "react";
import { TestContext } from "../../../store/testContext";
import { addQuestion, changeQuestion, toggleQuestionFormOpen } from "../../../store/testActions";
import FormEditQuestionFooter from "../FormEditQuestion/FormEditQuestionFooter";

interface IProps {
  ID?: string;
  editQuestion?: () => void;
}

const FormAddQuestion: FC<IProps> = ({ ID, editQuestion }) => {
  const methods = useForm<IQuestionForm>();
  const { handleSubmit, watch, setValue } = methods;
  const answers = watch("Answers");

  const {
    dispatch,
    state: { Questions }
  } = useContext(TestContext);

  const question = Questions.find(question => question.ID === ID);
  const isEditCurrentQuestion = !!(question && ID);

  const onSubmit: SubmitHandler<IQuestionForm> = data => {
    if (isEditCurrentQuestion) {
      dispatch(changeQuestion({ ID, Description: data.Description, Answers: data.Answers, Type: data.Type }));
      editQuestion && editQuestion();
    } else {
      dispatch(
        addQuestion({
          ID: new Date().getTime().toString(),
          Description: data.Description,
          Answers: data.Answers,
          Type: data.Type
        })
      );
      dispatch(toggleQuestionFormOpen(false));
    }
  };

  useEffect(() => {
    if (isEditCurrentQuestion) {
      setValue("Answers", [...question.Answers]);
      setValue("Description", question.Description);
      setValue("Type", question.Type);
    } else {
      setValue("Answers", [
        {
          ID: new Date().getTime().toString(),
          Description: "",
          IsCorrect: false
        },
        {
          ID: new Date().getTime().toString() + 1,
          Description: "",
          IsCorrect: false
        }
      ]);
    }
  }, []);

  return (
    <FormProvider {...methods}>
      <form className="p-5 bg-[#F3F4F6] rounded-md mb-5" onSubmit={handleSubmit(onSubmit)}>
        <QuestionTypeSelect />
        <QuestionDescription />

        {answers?.map((answer, index) => (
          <AnswerField key={answer.ID} id={answer.ID} answer={answer} index={index} />
        ))}

        <AddAnswerButton />

        {isEditCurrentQuestion ? <FormEditQuestionFooter editQuestion={editQuestion} /> : <FormAddQuestionFooter />}
      </form>
    </FormProvider>
  );
};
export default FormAddQuestion;
